export const API_GET_CITIES_POSTALCODE = "API_GET_CITIES_POSTALCODE";
export const API_GET_CITIES_POSTALCODE_SUCCESS = "API_GET_CITIES_POSTALCODE_SUCCESS";
export const API_GET_CITIES_POSTALCODE_FAIL = "API_GET_CITIES_POSTALCODE_FAIL";

export const RESET_LIST = "RESET_LIST";
export const RESET_WORK_LIST = "RESET_WORK_LIST";
